import { render, staticRenderFns } from "./WizardPageHeader.vue?vue&type=template&id=22e8a7c1&"
import script from "./WizardPageHeader.vue?vue&type=script&lang=js&"
export * from "./WizardPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./WizardPageHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports